import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ViolationTypeResponse } from '@/types/apps/violation-type.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ViolationTypeServiceInterface {}

type ViolationTypeGraphQLListResponse = GqlListResponse<ViolationTypeResponse>;

export class ViolationTypeGraphQLService
    extends BaseService
    implements ViolationTypeServiceInterface
{
    public getEntityName(): string {
        return 'violationType';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
        };
    }

    public async index(
        query: string
    ): Promise<ViolationTypeGraphQLListResponse> {
        return this.fetchGqlList<ViolationTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('violationType', {
            userId: this.getQueryById(),
        });
    }
}
